var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLinkBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2E67D1",
  d: "M15.5 5.667v-3.63C15.5 1.465 15.036 1 14.463 1h-3.63a.519.519 0 0 0 0 1.037h2.897L7.722 8.045a.519.519 0 1 0 .733.733l6.008-6.007v2.896a.519.519 0 0 0 1.037 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2E67D1",
  d: "M2.537 4.63c0-.86.696-1.556 1.556-1.556H7.98a.519.519 0 1 0 0-1.037H4.093A2.593 2.593 0 0 0 1.5 4.63v7.778A2.593 2.593 0 0 0 4.093 15h7.777a2.593 2.593 0 0 0 2.593-2.592v-3.89a.519.519 0 0 0-1.037 0v3.89c0 .859-.697 1.555-1.556 1.555H4.093c-.86 0-1.556-.696-1.556-1.555z"
})));
export default SvgExternalLinkBlue;